import React, { useRef } from "react";
import Slider from "react-slick"; // Import React Slick
import "slick-carousel/slick/slick.css"; // Import slick styles
import "slick-carousel/slick/slick-theme.css"; // Import slick theme styles
import { GrNext, GrPrevious } from "react-icons/gr"; // Import icons
import prayagraj1 from "../assets/prayagraj3.jpeg";
import prayagraj2 from "../assets/prayagraj4.jpeg";
import prayagraj3 from "../assets/prayagraj5.jpeg";

const PlacesToVisit = () => {
  const sliderRef = useRef(null);

  const images = [
    { id: 1, src: prayagraj1, alt: "Prayagraj 1" },
    { id: 2, src: prayagraj2, alt: "Prayagraj 2" },
    { id: 3, src: prayagraj3, alt: "Prayagraj 3" },
  ];

  const settings = {
    dots: false, // Optional, adds navigation dots
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false, // Optionally hide arrows on smaller screens
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true, // Show dots for mobile navigation
        },
      },
    ],
  };

  return (
    <div className="flex flex-wrap md:flex-nowrap items-center justify-center md:justify-between px-4 md:px-8 py-8 md:py-20">
      <div className="w-full md:w-1/2 mb-4 md:mb-0">
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-800 mb-3">Places to Visit in Prayagraj</h2>
        <p className="text-base md:text-lg text-gray-600">
          Explore the major tourist attractions in Prayagraj such as Sangam, Allahabad Fort, and more.
        </p>
      </div>

      <div className="w-full md:w-1/2">
        <Slider ref={sliderRef} {...settings}>
          {images.map((image) => (
            <div key={image.id} className="h-64 md:h-96 relative">
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover rounded-lg" />
            </div>
          ))}
        </Slider>
        <button
          onClick={() => sliderRef.current.slickPrev()}
          className="absolute left-0 top-1/2 -translate-y-1/2 bg-black text-white p-2 rounded-full z-10 hidden md:block"
        >
          <GrPrevious />
        </button>
        <button
          onClick={() => sliderRef.current.slickNext()}
          className="absolute right-0 top-1/2 -translate-y-1/2 bg-black text-white p-2 rounded-full z-10 hidden md:block"
        >
          <GrNext />
        </button>
      </div>
    </div>
  );
};

export default PlacesToVisit;
